export default "__VITE_ASSET__7TS1ApaQ__";